import React, { useContext, Fragment, useEffect } from "react";
import { TipoNegociacaoContext } from "../TipoNegociacaoContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarTipoNegociacao = () => {
  const { values, setValues, resetScreen } = useContext(TipoNegociacaoContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={TipoNegociacaoContext}>
        <div className="col-12 col-md-4">
          <label>Descrição</label>
          <input
            className="form-control"
            type="text"
            name="TipoNegociacaoDescricao"
            value={values.searchData.TipoNegociacaoDescricao}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={TipoNegociacaoContext} />
    </Fragment>
  );
};

export default PesquisarTipoNegociacao;
